export const chartData = {
    accountPeriod: 30,
    billingReportPaymentStatisticsDTOS: [
        {
            billingCycle: '2020-08-01', // 账单周期
            receivableAmount: 6, // 账单金额
            dueDate: '2020-07-08', // 应付日期
            isOverdue: false, // 是否逾期
            daysOfOverdue: 1, // 逾期天数-- 如果为负,表示剩余天数
            writeOffRecord: [
                {
          // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司111', // 抬头
                    amount: 1, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                },
                {
                    // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司111', // 抬头
                    amount: 1, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                },
                {
                            // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司111', // 抬头
                    amount: 1, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                },
                {
                                    // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司111', // 抬头
                    amount: 1, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                },
                {
                    // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司111', // 抬头
                    amount: 1, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                }
            ],
            unWriteOffRecord: [
                {
          // 未核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司', // 抬头
                    amount: 1, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                }
            ]
        },
        {
            billingCycle: '2020-08-02', // 账单周期
            receivableAmount: 10, // 账单金额
            dueDate: '2020-08-08', // 应付日期
            isOverdue: false, // 是否逾期
            daysOfOverdue: 3, // 逾期天数-- 如果为负,表示剩余天数
            writeOffRecord: [
                {
          // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司1', // 抬头
                    amount: 2, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                },
                {
          // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司2', // 抬头
                    amount: 2, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                }
            ],
            unWriteOffRecord: [
                {
          // 未核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司', // 抬头
                    amount: 2, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                }
            ]
        },
        {
            billingCycle: '2020-08-03', // 账单周期
            receivableAmount: 10, // 账单金额
            dueDate: '2020-10-08', // 应付日期
            isOverdue: false, // 是否逾期
            daysOfOverdue: 5, // 逾期天数-- 如果为负,表示剩余天数
            writeOffRecord: [
                {
          // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司', // 抬头
                    amount: 3, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                },
                {
          // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司', // 抬头
                    amount: 3, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                }
            ],
            unWriteOffRecord: [
                {
          // 未核销部分记录
                    invoiceTitle: null, // 抬头
                    amount: 3, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                }
            ]
        },
        {
            billingCycle: '2020-08-04', // 账单周期
            receivableAmount: 200, // 账单金额
            dueDate: '2020-11-08', // 应付日期
            isOverdue: true, // 是否逾期
            daysOfOverdue: 0, // 逾期天数-- 如果为负,表示剩余天数
            writeOffRecord: [
                {
          // 已核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司111', // 抬头
                    amount: 4, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                }
            ],
            unWriteOffRecord: [
                {
          // 未核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司', // 抬头
                    amount: 1, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                },
                {
                    // 未核销部分记录
                    invoiceTitle: '上海豪升国际物流有限公司', // 抬头
                    amount: 4, // 金额
                    writeOffTime: '2020-08-09', // 实际付款日期
                    actualAccountPeriod: 20 // 实际账期
                }
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/components/place-order/data.js